import { addOrRemove, debounce } from '../functions'

document.addEventListener('DOMContentLoaded', function (e) {
  const ptProjects = e.target.querySelector('.pt-projects')

  if (ptProjects) {
    const jsProjectsList = ptProjects.querySelector('.js-projects-list')
    const jsProjectsFilters = ptProjects.querySelector('.js-projects-filters')
    const jsSearch = ptProjects.querySelector('.js-projects-search')
    const jsProjectsOverlay = ptProjects.querySelector('.js-projects-overlay')

    if (jsProjectsList && jsProjectsFilters && jsSearch) {
      const setAnimationOnHover = () => {
        const feedsProject = jsProjectsList.querySelectorAll('.feed-project')
        feedsProject.forEach((e) => {
          if (!e.classList.contains('feed-project--is-working-progress')) {
            e.addEventListener('mouseenter', (r) => {
              r.target.classList.add('active')
              jsProjectsOverlay.classList.add('active')
              jsProjectsOverlay.style.height =
                jsProjectsList.offsetHeight + 'px'
            })
            e.addEventListener('mouseleave', (r) => {
              r.target.classList.remove('active')
              jsProjectsOverlay.style.height = 'auto'
              jsProjectsOverlay.classList.remove('active')
            })
          }
        })
      }
      const getProjectsFiltered = (search, terms) => {
        const options = {
          method: 'POST',
          body: new URLSearchParams({
            filters: new URLSearchParams({ search: search, terms: terms }),
            action: 'vn_projects_filtered',
            _ajax_nonce: vnObject.projectsFilteredNonce,
          }),
          headers: {
            Accept: 'application/x-www-form-urlencoded',
          },
        }

        fetch(vnObject.ajaxUrl, options)
          .then((response) => response.json())
          .then((res) => {
            jsProjectsList.style.opacity = 0
            setTimeout(() => {
              jsProjectsList.innerHTML = res.data.projects_output
              setAnimationOnHover()
              jsProjectsList.style.opacity = 1
            }, 300)
          })
          .catch((error) => {
            console.error('Erreur:', error)
          })
      }

      const termsIds = []

      const handleInput = debounce(() => {
        getProjectsFiltered(jsSearch.value, termsIds)
      }, 300)

      jsSearch.addEventListener('input', handleInput)

      jsProjectsFilters.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', function () {
          button.classList.toggle('active')
          const dataId = button.dataset.term
          addOrRemove(termsIds, dataId)
          getProjectsFiltered(jsSearch.value, termsIds)
        })
      })
      setAnimationOnHover()
    }
  }
})
